import { ChangeEvent } from "react";
import { TextField, styled, Button } from "@mui/material";

import colors from "theme/themeConstants";
import { ToggleButton } from "components/buttons/ToggleButton";
import { useIsAuth } from "hooks";

interface IProps {
  comment: string;
  onChangeComment: (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
  isCanContact: boolean;
  handleIsCanContact: () => void;
  report: () => void;
}

const ReportStepTwo = (props: IProps) => {
  const {
    comment,
    onChangeComment,
    isCanContact,
    handleIsCanContact,
    report
  } = props;

  const isAuth = useIsAuth();

  return (
    <Main>
      <p style={{ margin: "18px 0" }}>Is there are anything alse you want to add?</p>
      <TextField
        value={comment}
        multiline={true}
        onChange={onChangeComment}
        rows={5}
        sx={{
          width: "100%",
          borderRadius: "12px",
          marginBottom: "1rem",
          "textarea": {
            fontFamily: "'Poppins', sans-serif",
            fontSize: 14
          },
          "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
            borderRadius: "12px",
            border: "1px solid #D8DFEC"
          },
          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "1px solid #CD4CFF",
            borderRadius: "12px"
          }
        }}
      />
      {isAuth && (
        <Container>
          <p>Can we contact you for more information</p>
          <ToggleButton
            checked={isCanContact}
            onChange={handleIsCanContact}
          />
        </Container>
      )}
      <Button variant="contained" fullWidth sx={{
        background: colors.purpleGradient,
        minHeight: "3rem",
        fontSize: "16px",
        fontWeight: "500",
        borderRadius: "38px",
        marginBottom: "32px",
        marginTop: "4rem",
        boxShadow: "inherit",
        fontFamily: "'Poppins', sans-serif",
        "&:hover": {
          boxShadow: "inherit"
        }
      }} onClick={report}>
        Submit
      </Button>
    </Main>
  );
};

export default ReportStepTwo;

const Main = styled("div")({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  height: "100%"
});

const Container = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  "& p": {
    width: "50%"
  }
});
